<template>
  <svg
    style="display: block;height: auto; width: 100%;"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    width="970"
    height="970"
    viewBox="0 0 970 970"
    version="1.1"
    id="svg4785"
    sodipodi:docname="audit-new4.svg"
    inkscape:version="0.92.4 (unknown)"
  >
    <metadata id="metadata4789">
      <rdf:RDF>
        <cc:Work rdf:about>
          <dc:format>image/svg+xml</dc:format>
          <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title>Online İç Denetim</dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <sodipodi:namedview
      pagecolor="#ffffff"
      borderColor="#666666"
      borderopacity="1"
      objecttolerance="10"
      gridtolerance="10"
      guidetolerance="10"
      inkscape:pageopacity="0"
      inkscape:pageshadow="2"
      inkscape:window-width="1878"
      inkscape:window-height="1016"
      id="namedview4787"
      showgrid="false"
      inkscape:zoom="0.74861221"
      inkscape:cx="264.24898"
      inkscape:cy="514.85352"
      inkscape:window-x="42"
      inkscape:window-y="27"
      inkscape:window-maximized="1"
      inkscape:current-layer="svg4785"
    />
    <rect
      id="svgEditorBackground"
      x="-330.07666"
      y="-161.44191"
      width="1636"
      height="1261"
      style="fill:none;stroke:none"
    />
    <title id="title4734">{{ $t('title.onlineInternalAudit') }}</title>
    <desc id="desc4736">{{ $t('title.onlineInternalAudit') }} - Neta</desc>
    <defs id="defs4740">
      <path
        d="M 475.5,950.29971 C 213.27536,950.29971 0.70029455,737.72464 0.70029455,475.5 0.70029455,213.27536 213.27536,0.70029455 475.5,0.70029455 737.72464,0.70029455 950.29971,213.27536 950.29971,475.5 c 0,262.22464 -212.57507,474.79971 -474.79971,474.79971 z"
        id="path-1"
        inkscape:connector-curvature="0"
      />
      <path
        d="M 3.0280306,21.044362 C 3.2319569,14.868644 8.2533984,8.5708345 14.245738,6.9772773 L 35.983904,1.1963947 c 5.991442,-1.59331848 10.683101,2.1229791 10.479724,8.2820587 L 44.849434,58.362789 C 44.645783,64.530162 39.680429,71.01235 33.756462,72.841946 L 11.70764,79.651645 C 5.7848107,81.480889 1.148374,77.967989 1.3526509,71.781657 Z"
        id="path-3"
        inkscape:connector-curvature="0"
      />
    </defs>
    <g
      id="OnlineIcDenetim"
      style="fill:none;fill-rule:evenodd;stroke:none;stroke-width:1"
      transform="translate(-330.07665,-161.44191)"
    >
      <g id="Group-2" transform="translate(353,181)">
        <g id="Path-2">
          <mask id="mask-2" fill="white">
            <use xlink:href="#path-1" id="use4742" x="0" y="0" width="100%" height="100%" />
          </mask>
          <g id="Mask" style="fill-rule:nonzero" />
          <g id="Group" mask="url(#mask-2)" style="fill-rule:nonzero">
            <g transform="rotate(-133,518.09314,604.39584)" id="g4756">
              <a :href="links.whoWeAre">
                <path
                  d="m 732.59158,335.03569 c 79.04121,-36.49339 143.32809,-47.43654 192.86064,-32.82945 49.53256,14.60709 150.50828,56.66258 302.92718,126.16646 -84.3894,98.29056 -152.8752,161.41385 -205.4572,189.36986 -52.58211,27.95601 -133.66462,44.35281 -243.24756,49.19041 L 666.32406,626.29232 Z"
                  id="Rectangle-Copy"
                  transform="rotate(-99,947.35172,481.43802)"
                  inkscape:connector-curvature="0"
                  style="fill:#ffffff;stroke:none"
                />
                <title>{{ $t('title.whoWeAre') }}</title>
              </a>
              <a :href="links.contact">
                <path
                  d="m 415.8402,221.96288 c 92.90288,-75.31403 164.12059,-105.66749 213.65314,-91.0604 49.53256,14.60709 150.50827,56.66258 302.92715,126.16646 -84.3894,98.29056 -152.87513,161.41385 -205.4572,189.36986 -52.58208,27.95601 -154.59422,37.06406 -306.03642,27.32416 l -47.98333,-124.0333 z"
                  id="path4747"
                  transform="rotate(-146,652.68201,302.44055)"
                  inkscape:connector-curvature="0"
                  style="fill:#dfecff;stroke:none"
                />
                <title>{{ $t('title.contact') }}</title>
              </a>
              <a :href="links.definitions">
                <path
                  d="M 77.252302,391.63526 C 162.52034,307.59622 229.92063,272.88024 279.45318,287.48733 328.98573,302.09442 429.96145,344.14991 582.38032,413.65379 497.99093,511.94435 429.5052,575.06764 376.92312,603.02365 324.34105,630.97966 243.25854,647.37646 133.6756,652.21406 L 51.349773,526.45681 Z"
                  id="path4749"
                  transform="rotate(157,316.86505,468.22848)"
                  inkscape:connector-curvature="0"
                  style="fill:#ffffff;stroke:none"
                />
                <title>{{ $t('title.definitions') }}</title>
              </a>
              <a :href="links.howToRun">
                <path
                  d="m 135.08487,702.87847 c 104.34259,-29.3552 181.28017,-36.72925 230.81272,-22.12216 49.53255,14.60709 130.56536,88.9766 243.09843,223.10853 C 448.52135,977.17261 337.21887,1016.6636 275.08858,1022.338 212.95829,1028.0123 143.80191,1009.193 67.619436,965.88006 L 56.189666,827.29759 Z"
                  id="Rectangle"
                  transform="rotate(77,332.59284,848.40003)"
                  inkscape:connector-curvature="0"
                  style="fill:#dfecff;stroke:none"
                />
                <title>{{ $t('title.howToRun5Steps') }}</title>
              </a>
              <a :href="links.catalog">
                <path
                  d="M 403.32633,934.90951 371.27119,1071.9675 478.09673,1271.5581 834.61546,979.45608 C 719.50893,896.27031 637.2403,847.38997 585.23485,851.46559 c -46.6539,-33.17015 -108.17637,0.81904 -181.90852,83.44392 z"
                  id="path4752"
                  transform="rotate(35,603.08803,1050.696)"
                  inkscape:connector-curvature="0"
                  style="fill:#ffffff;stroke:#dfecff;stroke-width:1"
                />
                <title>{{ $t('title.catalog') }}</title>
              </a>
              <a :href="links.onlineInternalAudit">
                <path
                  d="m 726.13621,849.93422 c 41.99031,-81.83033 87.33575,-125.36009 136.03634,-130.58928 48.70058,-5.22919 142.60285,-9.32741 281.70685,-12.29464 -61.4879,163.37171 -110.7339,263.20743 -147.73812,299.5072 -37.00418,36.2997 -100.40825,76.036 -190.21221,119.2088 l -83.51371,-120.3958 z"
                  id="path4754"
                  inkscape:connector-curvature="0"
                  style="fill:#dfecff;stroke:none"
                />
              </a>
            </g>
          </g>
        </g>
        <circle
          id="Oval"
          cx="475.5"
          cy="475.5"
          r="227.59573"
          style="fill:#ffffff;fill-rule:nonzero"
        />
      </g>
      <g id="ga" transform="translate(667,676)" style="fill:#263746;fill-rule:nonzero" />
      <g id="time" transform="translate(780,232)" style="fill:#263746" />
      <g id="circle" transform="translate(792,936)" style="fill:#263746" />
      <g id="tick" transform="translate(1073,755)" style="fill:#263746" />
      <path
        d="M 662.83933,336.66295 721,458 C 671.47912,420.22086 635.54653,390.22086 613.20222,368 590.8579,345.77913 566.45716,315.77913 540,278 Z"
        id="Triangle"
        inkscape:connector-curvature="0"
        style="fill:#ffffff;fill-rule:nonzero"
      />
      <g id="galogo_tick" transform="translate(762,504)">
        <g id="g4780" transform="matrix(-1,0,0,1,127,0)">
          <g id="Rectangle-1" transform="rotate(22,-102.68531,238.47443)" style="fill:#367a64" />
          <g id="Rectangle-1-Clipped" transform="translate(64.943182,61.838095)">
            <mask id="mask-4" fill="white">
              <use xlink:href="#path-3" id="use4774" x="0" y="0" width="100%" height="100%" />
            </mask>
            <g id="g4777" />
          </g>
        </g>
      </g>
      <g id="chart" transform="translate(460,429)" />
      <path
        id="path5123"
        d="m 819.38975,634.23516 -1.4122,2.56616 c -0.5167,0.95109 -1.6189,1.34588 -2.6006,0.96903 -2.0322,-0.78958 -3.8921,-1.92012 -5.5282,-3.33779 -0.7922,-0.68191 -0.9989,-1.88424 -0.4822,-2.81738 l 1.4122,-2.56615 c -1.1883,-1.43561 -2.1183,-3.10451 -2.7383,-4.91697 h -2.8416 c -1.0333,0 -1.9289,-0.77164 -2.1011,-1.84834 -0.3444,-2.15342 -0.3616,-4.4145 0,-6.65764 0.1722,-1.07671 1.0678,-1.8663 2.1011,-1.8663 h 2.8416 c 0.62,-1.81245 1.55,-3.48135 2.7383,-4.91696 l -1.4122,-2.56615 c -0.5167,-0.93315 -0.3272,-2.13547 0.4822,-2.81738 1.6361,-1.41767 3.5133,-2.54821 5.5282,-3.33779 0.9817,-0.37685 2.0839,0.0179 2.6006,0.96903 l 1.4122,2.56615 c 1.8082,-0.34095 3.651,-0.34095 5.4593,0 l 1.4122,-2.56615 c 0.5167,-0.95109 1.6189,-1.34588 2.6005,-0.96903 2.0322,0.78958 3.8922,1.92012 5.5283,3.33779 0.7922,0.68191 0.9988,1.88423 0.4822,2.81738 l -1.4122,2.56615 c 1.1883,1.43561 2.1183,3.10451 2.7382,4.91696 h 2.8417 c 1.0333,0 1.9288,0.77164 2.101,1.84835 0.3445,2.15342 0.3617,4.4145 0,6.65764 -0.1722,1.07671 -1.0677,1.86629 -2.101,1.86629 h -2.8417 c -0.6199,1.81246 -1.5499,3.48136 -2.7382,4.91697 l 1.4122,2.56615 c 0.5166,0.93314 0.3272,2.13547 -0.4822,2.81738 -1.6361,1.41767 -3.5133,2.54821 -5.5283,3.33779 -0.9816,0.37685 -2.0838,-0.0179 -2.6005,-0.96903 l -1.4122,-2.56616 c -1.7911,0.34096 -3.6511,0.34096 -5.4593,0 z m -1.8084,-10.55173 c 6.6305,5.31176 14.1909,-2.56615 9.0932,-9.47502 -6.6304,-5.3297 -14.1908,2.56615 -9.0932,9.47502 z m -19.8568,27.61754 5.8038,3.01478 c 1.7394,1.04082 2.4971,3.24807 1.8083,5.22203 -1.5328,4.34272 -4.5466,8.32654 -7.3366,11.80789 -1.2744,1.59711 -3.4788,1.99191 -5.2182,0.95109 l -5.0116,-3.01478 c -2.7555,2.45848 -5.9588,4.4145 -9.4548,5.6886 v 6.02956 c 0,2.08164 -1.4295,3.87615 -3.3928,4.23505 -4.2365,0.75369 -8.6798,0.78959 -13.0714,0 -1.9805,-0.3589 -3.4444,-2.13547 -3.4444,-4.23505 v -6.02956 c -3.496,-1.29205 -6.6993,-3.23012 -9.4548,-5.6886 l -5.0116,2.99684 c -1.7222,1.04081 -3.9438,0.64602 -5.2182,-0.9511 -2.79,-3.48135 -5.7349,-7.46517 -7.2677,-11.78994 -0.6889,-1.95602 0.069,-4.16327 1.8083,-5.22203 l 5.7349,-3.01478 c -0.6716,-3.75053 -0.6716,-7.60873 0,-11.3772 l -5.7349,-3.03273 c -1.7394,-1.04081 -2.5144,-3.24806 -1.8083,-5.20408 1.5328,-4.34272 4.4777,-8.32654 7.2677,-11.80789 1.2744,-1.59712 3.4788,-1.99191 5.2182,-0.95109 l 5.0116,3.01478 c 2.7555,-2.45848 5.9588,-4.4145 9.4548,-5.6886 v -6.04751 c 0,-2.06369 1.4122,-3.8582 3.3755,-4.2171 4.2366,-0.7537 8.6971,-0.78959 13.0887,-0.0179 1.9805,0.35891 3.4444,2.13547 3.4444,4.23505 v 6.02956 c 3.496,1.29205 6.6993,3.23012 9.4548,5.6886 l 5.0116,-3.01478 c 1.7222,-1.04081 3.9438,-0.64602 5.2182,0.95109 2.79,3.48136 5.7177,7.46517 7.2504,11.80789 0.6889,1.95602 0.017,4.16327 -1.7221,5.22203 l -5.8038,3.01478 c 0.6716,3.76848 0.6716,7.62668 0,11.39515 z m -20.253,3.78642 c 10.1954,-13.81774 -4.9427,-29.5915 -18.2036,-18.96799 -10.1954,13.81774 4.9427,29.5915 18.2036,18.96799 z m 41.9182,32.78573 -1.4122,2.56615 c -0.5167,0.9511 -1.6189,1.34589 -2.6006,0.96904 -2.0322,-0.78959 -3.8921,-1.92013 -5.5282,-3.33779 -0.7922,-0.68192 -0.9989,-1.88424 -0.4822,-2.81739 l 1.4122,-2.56615 c -1.1883,-1.43561 -2.1183,-3.1045 -2.7383,-4.91696 h -2.8416 c -1.0333,0 -1.9289,-0.77164 -2.1011,-1.84835 -0.3444,-2.15341 -0.3616,-4.4145 0,-6.65764 0.1722,-1.0767 1.0678,-1.86629 2.1011,-1.86629 h 2.8416 c 0.62,-1.81245 1.55,-3.48135 2.7383,-4.91696 l -1.4122,-2.56615 c -0.5167,-0.93315 -0.3272,-2.13547 0.4822,-2.81738 1.6361,-1.41767 3.5133,-2.54821 5.5282,-3.3378 0.9817,-0.37684 2.0839,0.018 2.6006,0.96904 l 1.4122,2.56615 c 1.8082,-0.34096 3.651,-0.34096 5.4593,0 l 1.4122,-2.56615 c 0.5167,-0.95109 1.6189,-1.34588 2.6005,-0.96904 2.0322,0.78959 3.8922,1.92013 5.5283,3.3378 0.7922,0.68191 0.9988,1.88423 0.4822,2.81738 l -1.4122,2.56615 c 1.1883,1.43561 2.1183,3.10451 2.7382,4.91696 h 2.8417 c 1.0333,0 1.9288,0.77164 2.101,1.84835 0.3445,2.15341 0.3617,4.4145 0,6.65764 -0.1722,1.07671 -1.0677,1.86629 -2.101,1.86629 h -2.8417 c -0.6199,1.81246 -1.5499,3.48135 -2.7382,4.91696 l 1.4122,2.56615 c 0.5166,0.93315 0.3272,2.13547 -0.4822,2.81739 -1.6361,1.41766 -3.5133,2.5482 -5.5283,3.33779 -0.9816,0.37685 -2.0838,-0.0179 -2.6005,-0.96904 l -1.4122,-2.56615 c -1.7911,0.34096 -3.6511,0.34096 -5.4593,0 z m -1.8084,-10.56967 c 6.6305,5.31175 14.1909,-2.56615 9.0932,-9.47502 -6.6304,-5.31176 -14.1908,2.56615 -9.0932,9.47502 z"
        inkscape:connector-curvature="0"
        style="fill:currentColor;stroke-width:0.17579801"
      />
      <router-link
        :to="isAuthenticated ? { name: 'process' } : { name: 'signup', query: redirectQuery }"
        class="link-item"
      >
        <image
          class="link-item-content"
          y="500"
          x="700"
          id="image142"
          xlink:href="../assets/gear-logo.png"
          width="260"
          preserveAspectRatio="none"
        />
        <text
          class="link-item-content"
          xml:space="preserve"
          id="text264"
          style="font: bold 27px/1.25 Nunito; font-feature-settings: normal; text-align: start; letter-spacing: 0px; word-spacing: 0px; writing-mode: lr-tb; text-anchor: start; fill: rgb(0, 0, 0); fill-opacity: 1; stroke: none; stroke-width: 1.00009;"
        >
          <tspan
            sodipodi:role="line"
            id="tspan262"
            x="720"
            y="780"
            style="font-style: normal; font-variant: normal; font-weight: bold; font-stretch: normal; font-size: 27px; font-family: Nunito; font-feature-settings: normal; text-align: start; writing-mode: lr-tb; text-anchor: start; stroke-width: 1.00009;"
          >
            {{ $t('title.startToAudit').toLocaleUpperCase(lang) }}
          </tspan>
        </text>
        <title>{{ $t('title.startToAudit') }}</title>
      </router-link>
    </g>
    <a :href="links.onlineInternalAudit" class="link-item">
      <text
        class="link-item-content"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:40.00368118px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.00009203"
        x="781.44263"
        y="368.65811"
        id="text188"
      >
        <tspan
          sodipodi:role="line"
          x="445"
          y="210"
          style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:24.0022068px;font-family:Nunito;-inkscape-font-specification:'Nunito, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:1.00009203"
          id="tspan190"
        >
          ONLINE İÇ
        </tspan>
      </text>
      <text
        class="link-item-content"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:40.00368118px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.00009203"
        x="740"
        y="200"
        id="text196"
      >
        <tspan
          sodipodi:role="line"
          id="tspan194"
          x="410"
          y="240"
          style="font-style:normal;font-variant:normal;font-weight:600;font-stretch:normal;font-size:24.0022068px;font-family:Nunito;-inkscape-font-specification:'Nunito,  weight=280';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:1.00009203"
        >
          <tspan
            style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:24.0022068px;font-family:Nunito;-inkscape-font-specification:'Nunito, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start"
            id="tspan217"
          >
            DENETİM NEDİR?
          </tspan>
        </tspan>
      </text>
      <title>{{ $t('title.onlineInternalAudit') }}</title>
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 468.24504,170.61979 c -2.34755,-2.59169 -2.57734,-5.62224 -2.96289,-39.07589 -0.22987,-19.94648 -0.0461,-38.253642 0.4085,-40.682596 1.40952,-7.531972 4.71189,-9.610964 15.26649,-9.610964 9.178,0 9.25173,-0.0291 10.12203,-3.991507 1.02775,-4.6793 6.41734,-9.367772 10.76866,-9.367772 3.96183,0 10.9842,5.929436 11.52477,9.731075 0.37909,2.666026 1.37012,3.026629 9.97124,3.628204 16.00591,1.119483 15.16435,-1.433322 15.16435,45.99931 0,34.25954 -0.30914,40.68286 -2.07965,43.21062 -2.04993,2.9267 -2.53354,2.9691 -33.85911,2.9691 -30.6014,0 -31.8738,-0.10415 -34.32439,-2.80958 z m 44.07625,-31.07968 c 7.78995,-8.35245 14.16355,-16.05515 14.16355,-17.11712 0,-1.06197 -1.86665,-3.69654 -4.1481,-5.8546 l -4.1481,-3.92374 -10.98512,11.7014 -10.98511,11.70141 -4.97924,-5.54655 -4.97923,-5.54654 -4.60222,4.46065 c -2.53122,2.45335 -4.60222,4.89633 -4.60222,5.42884 0,2.06885 16.82155,19.66442 18.90067,19.77035 1.21086,0.0617 8.57517,-6.72165 16.36512,-15.0741 z m -6.63876,-55.045371 c 2.75493,-2.754934 2.6493,-4.030341 -0.60316,-7.2828 -2.14646,-2.146468 -3.24588,-2.411652 -5.34371,-1.288929 -2.93671,1.571685 -3.51172,6.594337 -1.03813,9.067924 2.17724,2.177241 4.47478,2.014026 6.985,-0.496195 z"
        id="path5073"
        inkscape:connector-curvature="0"
      >
        <title>{{ $t('title.onlineInternalAudit') }}</title>
      </path>
    </a>
    <a :href="links.catalog" class="link-item">
      <text
        class="link-item-content"
        xml:space="preserve"
        style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:24.0022068px;line-height:1.25;font-family:Nunito;-inkscape-font-specification:'Nunito, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.00009203"
        x="500"
        y="300"
        id="text240"
      >
        <tspan
          sodipodi:role="line"
          id="tspan238"
          x="755"
          y="385"
          style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:24.0022068px;font-family:Nunito;-inkscape-font-specification:'Nunito, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:1.00009203"
        >
          {{ $t('title.catalog').toLocaleUpperCase(lang) }}
        </tspan>
      </text>
      <title>{{ $t('title.catalog') }}</title>
      <path
        class="link-item-content"
        id="path4970"
        d="m 772.37435,273.06229 a 7.9265796,8.080722 0 1 0 7.9265,8.08072 7.9265796,8.080722 0 0 0 -7.9265,-8.08072 z m 0,26.93574 a 7.9265796,8.080722 0 1 0 7.9265,8.08072 7.9265796,8.080722 0 0 0 -7.9265,-8.08072 z m 0,26.93574 a 7.9265796,8.080722 0 1 0 7.9265,8.08072 7.9265796,8.080722 0 0 0 -7.9265,-8.08072 z m 73.9814,2.69357 h -52.8439 a 2.6421931,2.6935739 0 0 0 -2.6422,2.69358 v 5.38714 a 2.6421931,2.6935739 0 0 0 2.6422,2.69358 h 52.8439 a 2.6421931,2.6935739 0 0 0 2.6422,-2.69358 v -5.38714 a 2.6421931,2.6935739 0 0 0 -2.6422,-2.69358 z m 0,-53.87147 h -52.8439 a 2.6421931,2.6935739 0 0 0 -2.6422,2.69357 v 5.38714 a 2.6421931,2.6935739 0 0 0 2.6422,2.69358 h 52.8439 a 2.6421931,2.6935739 0 0 0 2.6422,-2.69358 v -5.38714 a 2.6421931,2.6935739 0 0 0 -2.6422,-2.69357 z m 0,26.93573 h -52.8439 a 2.6421931,2.6935739 0 0 0 -2.6422,2.69358 v 5.38715 a 2.6421931,2.6935739 0 0 0 2.6422,2.69357 h 52.8439 a 2.6421931,2.6935739 0 0 0 2.6422,-2.69357 v -5.38715 a 2.6421931,2.6935739 0 0 0 -2.6422,-2.69358 z"
        inkscape:connector-curvature="0"
        style="fill:currentColor;stroke-width:0.16673498"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 806.69571,285.9868 c 7.53129,-0.23812 19.85522,-0.23812 27.38652,0 7.53129,0.23814 1.36932,0.43296 -13.69326,0.43296 -15.06259,0 -21.22456,-0.19482 -13.69326,-0.43296 z"
        id="path4981"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 791.51161,283.72147 c -0.40644,-1.05922 -0.52965,-3.01302 -0.27372,-4.34177 0.43123,-2.23907 2.51743,-2.41591 28.50142,-2.41591 h 28.03618 l 0.41863,4.34176 0.41864,4.34177 h -28.18109 c -23.30994,0 -28.3088,-0.33289 -28.92006,-1.92585 z"
        id="path4983"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 791.51161,310.44002 c -0.40644,-1.05921 -0.52965,-3.01301 -0.27372,-4.34177 0.43123,-2.23906 2.51743,-2.4159 28.50142,-2.4159 h 28.03618 l 0.41863,4.34176 0.41864,4.34177 h -28.18109 c -23.30994,0 -28.3088,-0.33289 -28.92006,-1.92586 z"
        id="path4985"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 792.39549,338.49 c -0.88108,-1.06169 -1.40553,-3.31607 -1.16551,-5.00972 l 0.43654,-3.07937 h 28.05449 28.05448 l 0.44094,3.86283 c 0.25052,2.19404 -0.32663,4.34947 -1.33593,4.98926 -0.97729,0.61955 -13.27572,1.13566 -27.32991,1.14691 -20.6697,0.0165 -25.85918,-0.34844 -27.1551,-1.90991 z"
        id="path4987"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 767.21908,340.15319 c -2.83106,-2.83104 -1.90228,-8.82672 1.73666,-11.21105 3.09388,-2.02717 3.58583,-2.02717 6.67971,0 2.23531,1.46463 3.33981,3.41518 3.33981,5.89813 0,4.64043 -2.19791,6.91602 -6.67972,6.91602 -1.91037,0 -4.19478,-0.72139 -5.07646,-1.6031 z"
        id="path4989"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 767.21908,313.43462 c -3.87406,-3.87403 -0.13622,-13.0921 5.30858,-13.0921 2.98168,0 6.4476,4.4013 6.4476,8.18757 0,4.25118 -2.31612,6.50765 -6.67972,6.50765 -1.91037,0 -4.19478,-0.7214 -5.07646,-1.60312 z"
        id="path4991"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 767.21908,286.71606 c -0.88169,-0.88171 -1.60315,-3.1932 -1.60315,-5.13665 0,-9.15756 12.24232,-10.55609 13.1165,-1.4984 0.23383,2.4227 -0.29072,5.26741 -1.1656,6.32154 -1.93328,2.32946 -8.14365,2.51761 -10.34775,0.31351 z"
        id="path4993"
        inkscape:connector-curvature="0"
      />
      <title>{{ $t('title.catalog') }}</title>
    </a>
    <a :href="links.howToRun" class="link-item">
      <text
        class="link-item-content"
        xml:space="preserve"
        style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:24.0022068px;line-height:1.25;font-family:Nunito;-inkscape-font-specification:'Nunito, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.00009203"
        x="1028.5892"
        y="889.67004"
        id="text244"
      >
        <tspan sodipodi:role="line" id="tspan248" x="725" y="725">
          {{ $t('title.on5steps').toLocaleUpperCase(lang) }}
        </tspan>
      </text>
      <text
        class="link-item-content"
        xml:space="preserve"
        style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:24.0022068px;line-height:1.25;font-family:Nunito;-inkscape-font-specification:'Nunito, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.00009203"
        x="1028.5892"
        y="889.67004"
        id="text244"
      >
        <tspan sodipodi:role="line" id="tspan248" x="700" y="755">
          {{ $t('title.howToRun').toLocaleUpperCase(lang) }}
        </tspan>
      </text>
      <title>{{ $t('title.howToRun5Steps') }}</title>
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 760.53946,683.48667 c -0.88178,-0.88171 -1.60315,-3.227 -1.60315,-5.21175 0,-5.00837 -8.31946,-10.11539 -13.00239,-7.9817 -5.00956,2.28254 -6.21527,1.7832 -10.07783,-4.17384 -4.51742,-6.96691 -4.59392,-10.04188 -0.29853,-11.99901 2.93667,-1.33804 3.33981,-2.35689 3.33981,-8.44046 0,-6.08357 -0.40314,-7.10242 -3.33981,-8.44045 -4.22069,-1.92307 -4.20818,-4.53822 0.056,-11.81508 3.55623,-6.06821 5.11857,-6.72772 10.32175,-4.35699 4.45631,2.03039 12.86278,-3.28504 12.94419,-8.18451 0.081,-4.85478 2.44612,-6.61284 8.89792,-6.61284 8.17095,0 9.86,0.99594 9.87191,5.82062 0.01,3.49424 0.90628,4.71055 5.35009,7.24825 4.12528,2.35585 5.92604,2.73566 7.91743,1.66991 4.52041,-2.41923 6.5661,-1.51993 10.04452,4.41556 4.26459,7.27686 4.27699,9.89201 0.056,11.81508 -2.93657,1.33803 -3.3398,2.35688 -3.3398,8.44045 0,6.08357 0.40323,7.10242 3.3399,8.44046 4.22059,1.92307 4.20819,4.53822 -0.056,11.81508 -3.55593,6.06775 -5.11867,6.72766 -10.32005,4.35777 -4.68293,-2.13369 -13.0023,2.97333 -13.0023,7.9817 0,5.12711 -2.31601,6.81487 -9.35156,6.81487 -3.37991,0 -6.86663,-0.72141 -7.74831,-1.60312 z m 17.09987,-28.64546 c 4.87715,-4.68816 4.71634,-13.7357 -0.33403,-18.78605 -7.10115,-7.10117 -19.5647,-3.47704 -21.71529,6.31431 -1.24552,5.671 2.45422,13.07855 7.6381,15.29257 5.39499,2.30423 10.02152,1.39863 14.41122,-2.82083 z"
        id="path5134"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 811.90569,635.03888 c -1.35943,-1.02988 -2.07209,-2.51906 -1.58375,-3.30928 1.51314,-2.44821 -0.69116,-6.84961 -4.07447,-8.13596 -4.46001,-1.69568 -4.46001,-7.5689 0,-9.26457 3.44431,-1.30952 5.32599,-5.10802 4.10567,-8.28805 -0.46424,-1.20968 0.61376,-2.66522 2.86017,-3.86201 2.80875,-1.49638 3.72894,-1.55176 4.16578,-0.25074 0.69046,2.05651 7.28327,2.20587 9.27895,0.21022 2.04049,-2.04055 7.32998,0.93357 6.90394,3.88186 -0.58326,4.03514 1.60935,8.26525 4.28409,8.26525 2.06009,0 2.58184,0.94497 2.58184,4.67576 0,3.64912 -0.53955,4.67575 -2.45743,4.67575 -3.03538,0 -5.98025,5.72313 -3.97606,7.72731 0.94329,0.94329 0.25962,2.1065 -2.1758,3.70229 -2.67385,1.75199 -3.93036,1.94774 -5.08577,0.79233 -1.88477,-1.88473 -9.01573,-2.04181 -9.01573,-0.19859 0,1.89221 -2.90327,1.58169 -5.81143,-0.62157 z m 14.47173,-10.90139 c 1.31452,-1.3145 2.01118,-3.80925 1.76526,-6.32153 -0.31183,-3.18718 -1.29092,-4.45939 -4.21969,-5.48321 -3.278,-1.14589 -4.16928,-0.89395 -6.34568,1.79379 -3.226,3.98398 -3.1938,6.17695 0.13981,9.51057 3.239,3.23898 5.77513,3.38553 8.6603,0.50038 z"
        id="path5136"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 811.75667,688.63227 c -1.36302,-0.99668 -2.03528,-2.49381 -1.50504,-3.35177 1.57525,-2.54872 -0.55545,-6.93854 -4.00416,-8.24974 -4.46001,-1.69568 -4.46001,-7.5689 0,-9.26458 3.44431,-1.30952 5.32599,-5.10801 4.10567,-8.28805 -0.46034,-1.19965 0.58206,-2.65154 2.72845,-3.80026 2.99198,-1.60126 3.63954,-1.58973 4.67233,0.0832 1.63115,2.64233 6.91414,2.7498 8.79401,0.17889 1.38523,-1.89438 1.87188,-1.87386 5.05707,0.21318 2.72835,1.78768 3.245,2.83128 2.28741,4.62051 -1.49674,2.79684 1.0994,6.94903 4.3449,6.94903 1.61295,0 2.1906,1.23303 2.1906,4.67575 0,3.73078 -0.52175,4.67575 -2.58184,4.67575 -2.64044,0 -4.86725,4.21359 -4.30449,8.14503 0.50034,3.49591 -3.52443,6.02972 -6.56331,4.13193 -3.09378,-1.93209 -9.26115,-2.10097 -9.26115,-0.25361 0,1.89395 -3.06068,1.65501 -5.96045,-0.4653 z m 14.0639,-10.26913 c 3.95796,-2.11824 3.56492,-10.25076 -0.58686,-12.14243 -6.76062,-3.08035 -13.1014,5.42043 -8.13585,10.90734 2.66115,2.9405 4.93456,3.26241 8.72271,1.23509 z"
        id="path5138"
        inkscape:connector-curvature="0"
      />
      <title>{{ $t('title.howToRun5Steps') }}</title>
    </a>
    <a :href="links.definitions" class="link-item">
      <text
        class="link-item-content"
        xml:space="preserve"
        style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:24.0022068px;line-height:1.25;font-family:Nunito;-inkscape-font-specification:'Nunito, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.00009203"
        x="776.09894"
        y="1070.0204"
        id="text256"
      >
        <tspan
          sodipodi:role="line"
          id="tspan254"
          x="450"
          y="910"
          style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:24.0022068px;font-family:Nunito;-inkscape-font-specification:'Nunito, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:1.00009203"
        >
          {{ $t('title.definitions').toLocaleUpperCase(lang) }}
        </tspan>
      </text>
      <title>{{ $t('title.definitions') }}</title>
      <path
        class="link-item-content"
        id="path4897"
        d="m 557.78656,796.78407 c -10.701,0.54141 -31.9704,2.51209 -45.1006,9.67749 -0.906,0.49441 -1.4196,1.37354 -1.4196,2.29273 v 63.345 c 0,2.0107 2.4663,3.2816 4.5459,2.3485 13.5091,-6.0617 33.0463,-7.7156 42.7065,-8.1682 3.2983,-0.1549 5.8622,-2.5121 5.8622,-5.3375 v -58.81355 c 0,-3.08307 -2.9973,-5.52551 -6.5944,-5.34447 z m -54.1867,9.67749 c -13.1283,-7.1654 -34.3975,-9.13434 -45.0986,-9.67749 -3.597,-0.18104 -6.5963,2.2614 -6.5963,5.34447 v 58.81525 c 0,2.8272 2.5639,5.1843 5.8621,5.3375 9.6641,0.4527 29.2112,2.1082 42.7202,8.1734 2.0738,0.9314 4.5323,-0.3377 4.5323,-2.3432 v -63.38854 c 0,-0.92092 -0.5117,-1.76524 -1.4197,-2.26139 z"
        inkscape:connector-curvature="0"
        style="fill:currentColor;stroke-width:0.18437655"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="M 512.45757,840.30919 V 806.8512 l 7.68161,-2.88364 c 10.11593,-3.79748 37.16642,-7.67559 40.2,-5.7633 1.94668,1.22715 2.25911,5.30125 2.57323,33.55082 0.33094,29.76311 0.18192,32.20741 -2.00388,32.87071 -1.29882,0.3942 -7.77191,1.3598 -14.38472,2.146 -6.61291,0.7861 -15.63044,2.3806 -20.03895,3.5434 -4.4086,1.1628 -9.36826,2.4152 -11.02141,2.783 l -3.00588,0.6689 z"
        id="path4908"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 498.24727,872.82719 c -1.35293,-1.3529 -17.11588,-4.6975 -28.53933,-6.0554 -6.61291,-0.7862 -13.086,-1.7518 -14.38482,-2.146 -2.1858,-0.6633 -2.33482,-3.1076 -2.00389,-32.87071 0.31413,-28.24957 0.62656,-32.32367 2.57334,-33.55082 3.03358,-1.91229 30.08397,1.96582 40.1999,5.7633 l 7.6816,2.88364 v 33.30219 c 0,31.4025 -0.13971,33.3022 -2.44922,33.3022 -1.34702,0 -2.73195,-0.2828 -3.07758,-0.6284 z"
        id="path4910"
        inkscape:connector-curvature="0"
      />
      <title>{{ $t('title.definitions') }}</title>
    </a>
    <a :href="links.contact" class="link-item">
      <text
        class="link-item-content"
        xml:space="preserve"
        style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:24.0022068px;line-height:1.25;font-family:Nunito;-inkscape-font-specification:'Nunito, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.00009203"
        x="494.21811"
        y="886.99817"
        id="text260"
      >
        <tspan
          sodipodi:role="line"
          id="tspan258"
          x="168.21811"
          y="725.99817"
          style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:24.0022068px;font-family:Nunito;-inkscape-font-specification:'Nunito, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:1.00009203"
        >
          {{ $t('title.contact').toLocaleUpperCase(lang) }}
        </tspan>
      </text>
      <title>{{ $t('title.contact') }}</title>
      <path
        class="link-item-content"
        id="path5188"
        d="M 257.19325,585.69909 H 174.4975 c -6.22802,0 -11.27669,4.99213 -11.27669,11.15042 v 81.76974 c 0,6.15829 5.04867,11.15042 11.27669,11.15042 h 82.69575 c 6.22799,0 11.27669,-4.99213 11.27669,-11.15042 v -81.76974 c 0,-6.15829 -5.0487,-11.15042 -11.27669,-11.15042 z m -52.12723,53.45325 C 183.7606,623.86303 183.97768,623.82447 178.2564,619.42145 v -5.84631 c 0,-3.07915 2.52434,-5.5752 5.63834,-5.5752 H 247.796 c 3.11401,0 5.63834,2.49605 5.63834,5.5752 v 5.84631 c -5.72552,4.40649 -5.50538,4.4425 -26.80962,19.73112 -2.46679,1.77826 -7.37497,6.06769 -10.77935,6.01519 -3.40721,0.0506 -8.30881,-4.23414 -10.77935,-6.01542 z m 48.36832,-10.29765 v 33.03893 c 0,3.07915 -2.52433,5.57521 -5.63834,5.57521 h -63.90126 c -3.114,0 -5.63834,-2.49606 -5.63834,-5.57521 v -33.03893 c 3.27916,2.50746 7.83001,5.86234 22.38963,16.31075 3.3271,2.40222 8.92151,7.4673 15.19864,7.43593 6.31657,0.0311 11.99018,-5.12012 15.20473,-7.43941 14.55586,-10.44539 19.10577,-13.80004 22.38494,-16.30727 z"
        inkscape:connector-curvature="0"
        style="fill:currentColor;stroke-width:0.23361203"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 167.96834,686.32875 -3.51998,-2.76881 v -45.89559 -45.8956 l 3.51998,-2.76881 c 3.40067,-2.67498 5.02463,-2.76883 47.91324,-2.76883 42.88861,0 44.51257,0.0938 47.91324,2.76883 l 3.51999,2.76881 v 45.8956 45.89559 l -3.51999,2.76881 c -3.40067,2.67498 -5.02463,2.76882 -47.91324,2.76882 -42.88861,0 -44.51257,-0.0938 -47.91324,-2.76882 z m 84.38407,-20.20914 c 1.70689,-1.70688 2.3945,-37.13879 0.72075,-37.13879 -0.48531,0 -5.74552,3.5281 -11.68937,7.84023 -27.09516,19.65695 -24.29508,19.70458 -52.32978,-0.89033 -5.20328,-3.82246 -9.86233,-6.9499 -10.35344,-6.9499 -1.68091,0 -1.0035,35.42512 0.71018,37.13879 2.28308,2.28308 70.65858,2.28308 72.94166,0 z m -14.99166,-33.87215 c 15.82792,-11.41691 16.56784,-12.16181 16.581,-16.69273 0.008,-2.6084 -0.70763,-5.46394 -1.58934,-6.34565 -2.28308,-2.28308 -70.65858,-2.28308 -72.94166,0 -0.88172,0.88171 -1.58675,3.73725 -1.56676,6.34565 0.0345,4.49767 0.83858,5.32889 15.57285,16.09794 17.39863,12.71637 21.26022,14.80759 24.87446,13.4706 1.37624,-0.50911 9.95748,-6.30322 19.06945,-12.87581 z"
        id="path5201"
        inkscape:connector-curvature="0"
      />
      <title>{{ $t('title.contact') }}</title>
    </a>
    <a :href="links.whoWeAre" class="link-item">
      <text
        class="link-item-content"
        xml:space="preserve"
        style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:24.0022068px;line-height:1.25;font-family:Nunito;-inkscape-font-specification:'Nunito, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.00009203"
        x="454.14029"
        y="546.33655"
        id="text264"
      >
        <tspan
          sodipodi:role="line"
          id="tspan262"
          x="120.14029"
          y="390.33655"
          style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:24.0022068px;font-family:Nunito;-inkscape-font-specification:'Nunito, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:1.00009203"
        >
          {{ $t('title.whoWeAre').toLocaleUpperCase(lang) }}
        </tspan>
      </text>
      <title>{{ $t('title.whoWeAre') }}</title>
      <path
        id="path5251"
        class="link-item-content"
        d="m 141.24481,301.36301 c 5.60828,0 10.16799,-5.4241 10.16799,-12.09554 0,-6.67145 -4.55971,-12.09554 -10.16799,-12.09554 -5.60828,0 -10.16799,5.42409 -10.16799,12.09554 0,6.67144 4.55971,12.09554 10.16799,12.09554 z m 71.17594,0 c 5.60829,0 10.168,-5.4241 10.168,-12.09554 0,-6.67145 -4.55971,-12.09554 -10.168,-12.09554 -5.60827,0 -10.16798,5.42409 -10.16798,12.09554 0,6.67144 4.55971,12.09554 10.16798,12.09554 z m 5.08401,6.04777 h -10.168 c -2.79619,0 -5.32231,1.34185 -7.16526,3.51527 6.40267,4.17674 10.94649,11.71755 11.93152,20.67581 h 10.48573 c 2.81209,0 5.084,-2.7026 5.084,-6.04777 v -6.04777 c 0,-6.67145 -4.55972,-12.09554 -10.16799,-12.09554 z m -40.67198,0 c 9.83435,0 17.79399,-9.46854 17.79399,-21.1672 0,-11.69865 -7.95964,-21.16719 -17.79399,-21.16719 -9.83436,0 -17.79398,9.46854 -17.79398,21.16719 0,11.69866 7.95962,21.1672 17.79398,21.1672 z m 12.2016,6.04777 h -1.31867 c -3.3046,1.88993 -6.9746,3.02388 -10.88293,3.02388 -3.90831,0 -7.56243,-1.13395 -10.88293,-3.02388 h -1.31866 c -10.10444,0 -18.30239,9.75203 -18.30239,21.77198 v 5.44298 c 0,5.0083 3.41581,9.07165 7.626,9.07165 h 45.75597 c 4.21018,0 7.62599,-4.06335 7.62599,-9.07165 v -5.44298 c 0,-12.01995 -8.19795,-21.77198 -18.30238,-21.77198 z m -35.54032,-2.5325 c -1.84295,-2.17342 -4.36906,-3.51527 -7.16526,-3.51527 h -10.16799 c -5.60828,0 -10.16799,5.42409 -10.16799,12.09554 v 6.04777 c 0,3.34517 2.27191,6.04777 5.084,6.04777 h 10.46985 c 1.00091,-8.95826 5.54473,-16.49907 11.94739,-20.67581 z"
        inkscape:connector-curvature="0"
        style="fill:currentColor;stroke-width:0.17328072"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 152.425,348.84476 c -3.72011,-1.32954 -5.34371,-4.89547 -5.34371,-11.73647 0,-9.13427 4.45198,-17.78389 10.81704,-21.01612 4.35714,-2.21258 5.472,-2.26961 11.95187,-0.61128 4.97564,1.27335 8.58854,1.4556 11.89374,0.59993 2.61097,-0.67594 5.94958,-1.52909 7.41913,-1.8959 3.50994,-0.87609 11.20009,4.37544 14.37979,9.81986 1.37553,2.35522 2.83945,7.56193 3.25317,11.57046 0.67865,6.57549 0.41441,7.62605 -2.70198,10.74243 l -3.45419,3.45419 -23.10548,-0.10547 c -12.70802,-0.058 -24.00724,-0.42774 -25.10938,-0.82163 z"
        id="path5262"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 210.8747,324.60941 c -1.26181,-3.55271 -3.81738,-8.10302 -5.67906,-10.11179 -1.86168,-2.00878 -3.039,-4.21195 -2.61628,-4.89592 0.42272,-0.68399 4.84811,-1.24361 9.83419,-1.24361 11.03912,0 13.56704,2.08976 14.51956,12.00293 0.81202,8.45081 -0.92266,10.70785 -8.22968,10.70785 -5.40935,0 -5.58643,-0.1461 -7.82873,-6.45946 z"
        id="path5264"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 205.95908,296.82255 c -5.51599,-7.01245 -1.33672,-19.19079 6.58575,-19.19079 4.17549,0 9.34843,6.29172 9.34843,11.37029 0,9.98205 -10.26929,15.02222 -15.93418,7.8205 z"
        id="path5266"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 170.13437,304.82503 c -6.35985,-3.13529 -9.90008,-9.70317 -9.97925,-18.51365 -0.15571,-17.32961 16.6097,-26.93825 27.35299,-15.67661 9.4871,9.94485 8.09708,26.01882 -2.88442,33.35493 -5.33431,3.56356 -8.57606,3.75045 -14.48932,0.83533 z"
        id="path5268"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 135.05794,297.67067 c -4.17168,-4.17167 -3.70428,-13.68918 0.84812,-17.2701 4.54469,-3.57485 7.35318,-3.49738 10.9218,0.30125 4.27016,4.54537 4.87696,10.135 1.66084,15.29895 -3.22649,5.18058 -9.17988,5.92079 -13.43076,1.6699 z"
        id="path5270"
        inkscape:connector-curvature="0"
      />
      <path
        class="link-item-content"
        style="fill:#263746;fill-opacity:1;stroke-width:1.33592796"
        d="m 128.64548,329.46576 c -0.88171,-0.88172 -1.60311,-4.68451 -1.60311,-8.45066 0,-9.65847 3.3571,-12.6643 14.11334,-12.63655 10.10575,0.0261 12.33414,1.27423 8.48685,4.75365 -3.54988,3.21046 -7.90498,11.591 -7.90498,15.2116 0,2.32032 -0.85322,2.72507 -5.74449,2.72507 -3.15947,0 -6.4659,-0.72139 -7.34761,-1.60311 z"
        id="path5272"
        inkscape:connector-curvature="0"
      />
      <title>{{ $t('title.whoWeAre') }}</title>
    </a>
  </svg>
</template>
<script>
import { mapGetters } from 'vuex'
import { APP_ID, WEBSITE_URL } from '../_helpers/config'
import { redirectQuery } from '../_helpers/redirect'

export default {
  data () {
    return {
      lang: 'tr-TR',
      animateTimeout: 250,
      // These pages moved to the public site; same targets as its _redirects.
      links: {
        whoWeAre: `${WEBSITE_URL}/#biz-kimiz`,
        contact: `${WEBSITE_URL}/#biz-kimiz`,
        definitions: WEBSITE_URL,
        howToRun: `${WEBSITE_URL}/#nasil-calisir`,
        catalog: `${WEBSITE_URL}/denetim-paketleri`,
        onlineInternalAudit: WEBSITE_URL
      }
    }
  },
  mounted () {
    if (APP_ID !== 1) {
      this.lang = 'en-US'
    }
    this.loadLinkItemsHover()
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
    // The login page's redirect, kept on the way to sign-up.
    redirectQuery () {
      return redirectQuery(this.$route.query)
    }
  },
  methods: {
    loadLinkItemsHover () {
      const linkItemList = []
      const linkItems = document.querySelectorAll('.link-item')
      linkItems.forEach((linkItem, index) => {
        if (index !== 0) {
          linkItemList.push(linkItem)
        }
      })
      linkItemList.push(linkItems[1])
      linkItemList.push(linkItems[0])
      linkItemList.push(linkItems[0])

      let timer = this.animateTimeout

      linkItemList.forEach(linkItem => {
        const contents = linkItem.querySelectorAll('.link-item-content')

        const mouseover = () => {
          contents.forEach(path => {
            path.style.fill = '#31b4cb'
            path.classList.add('icon-shadow')
          })
        }

        const mouseout = () => {
          contents.forEach(path => {
            path.style.fill = 'rgb(38, 55, 70)'
            path.classList.remove('icon-shadow')
          })
        }

        window.setTimeout(() => {
          mouseover()
          window.setTimeout(mouseout, this.animateTimeout - 50)
        }, timer)

        timer += this.animateTimeout

        linkItem.addEventListener('mouseover', mouseover, false)
        linkItem.addEventListener('mouseout', mouseout, false)
      })
    }
  }
}
</script>
<style scoped>
.icon-shadow {
  -webkit-filter: drop-shadow(1px 1px 0px rgba(0, 0, 0, 0.3));
  filter: drop-shadow(1px 1px 0px rgba(0, 0, 0, 0.3));
}
</style>
